<template>
  <li class="pager__item">
    <a @click.prevent="click" href="#" class="pager__link"
       :class="{'pager__link--active':page.active, 'pager__link--disabled':page.disabled}"
       :title="page.title">{{page.label}}</a>
  </li>
</template>
<script>
import {useStore} from "vuex";

export default {
  name: "PaginationItem",
  props: ['page'],
  setup(props, {emit}) {
    const store = useStore()
    const click = () =>{
        store.dispatch('setPage', props.page.number);
        emit('pageChanged');
    }
    return {
      click,
    }
  }
}
</script>